import React from "react";
import { useTimer } from "react-timer-hook";

export default function CountDownTimer({
  expiry = 30000,
  startTimer = true,
  setIsExpired = () => {},
}) {
  // react-timer-hook ≥4 requires a Date here (it calls .getTime()); a bare
  // number crashes the OTP step with "e.getTime is not a function".
  const { seconds } = useTimer({
    expiryTimestamp: new Date(Date.now() + expiry),
    onExpire: () => setIsExpired(true),
    // autoStart: false,
  });

  // useEffect(() => {
  // console.log("seconds", seconds);
  // console.log(" expiry", Date.now() + expiry);
  // }, [seconds]);

  return <>{seconds}s</>;
}
